<template lang="pug">
.wrapp-not-found
  div Page not found!
  button.global-btn(@click="navToLanding") Go to home
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
// import { useReCaptcha } from "vue-recaptcha-v3";
import { CompanyStore } from "@/store/companyStore";
import { UserStore } from "@/store/userStore";
import { defaultStore } from "@/store";

const router = useRouter();
const companyStore = CompanyStore();
const userStore = UserStore();

const store = defaultStore();

async function setup() {
  // eslint-disable-next-line no-storage/no-browser-storage
  const jwt = localStorage.getItem("jwt");
  // await router.isReady();
  if (jwt) {
    store.setJWT(jwt);

    await companyStore.setupCompanies();
    await userStore.getUserData();

    router.push({
      name: "MyTasks",
      params: { companyId: companyStore.activeCompany?.cmp_id },
    });
  } else
    router.push({
      name: "AuthPage",
      // params: { companyId: companyStore.activeCompany?.cmp_id },
    });
}
function navToLanding() {
  setup();
}
</script>

<style lang="scss" scoped>
.wrapp-not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;

  .global-btn {
    margin-top: 30px;
    border: none;
  }
}
</style>
